import config from '../config';
import type { AuthUser, AuthTokens, AuthResponse } from '../../../shared/types';

export type { AuthUser, AuthTokens, AuthResponse };

async function post<T>(path: string, body: unknown, accessToken?: string): Promise<T> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (accessToken) headers.Authorization = `Bearer ${accessToken}`;

  const res = await fetch(`${config.apiUrl}${path}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
  if (res.status === 204) return undefined as T;
  const data = await res.json();
  if (!res.ok) throw new Error(data.error?.message ?? 'Request failed');
  return data as T;
}

export const authApi = {
  register: (email: string, password: string, displayName: string) =>
    post<AuthResponse>('/auth/register', { email, password, displayName }),

  login: (email: string, password: string) =>
    post<AuthResponse>('/auth/login', { email, password }),

  refresh: (refreshToken: string) =>
    post<AuthTokens>('/auth/refresh', { refreshToken }),

  logout: (accessToken: string, refreshToken: string) =>
    post<void>('/auth/logout', { refreshToken }, accessToken),
};
